import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./navItem.scss";
import NavItemHeader from "./NavItemHeader.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavItem = (props) => {
  const { label, Icon, CustomIcon, extraCustomIcon, to, onClick, children, isNew, show } = props.item;
  const { pathname } = useLocation();
  const navClass = pathname === "/" && label === "Dashboard" ? "secondary_navItem activeNavItem" : "secondary_navItem"


  if (children) {
    return <NavItemHeader item={props.item} />;
  }
  return (
    <>
      {show && (
        <NavLink
          to={onClick ? onClick : to}
          className={navClass}
          activeClassName="activeNavItem"
          onClick={()=> onClick && onClick.redirectURL()}
          onContextMenu ={(e)=> onClick && e.preventDefault()}
        >
          <span  
          >
            {CustomIcon ? <img className="navIcon" src={CustomIcon} alt="custom-icon" /> : <FontAwesomeIcon icon={Icon} className="navIcon" />}
            <span className="navLabel">{label}</span>
            {isNew && <span className="new-badge">New</span>}
          </span>
          <span>
            {extraCustomIcon ? <img className="customIcon_navItem" src={extraCustomIcon} alt="custom-icon" /> : null}
          </span>
        </NavLink>
      )}
    </>
  );
};

export default NavItem;